import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GHIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GH" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 8h16v4H0V8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M0 4h16v4H0V4Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M0 0h16v4H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="m8.038 7.245-1.743 1.21.557-2.071-1.28-1.323 1.733-.071.733-2.048.733 2.048h1.73L9.223 6.384l.639 1.948-1.825-1.087Z"
        clipRule="evenodd"
        opacity={0.9}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
